module.exports = {
      id: "lock-usage",
      viewBox: "0 0 21.203 27.836",
      url: "img/" + "sprite.svg#lock-usage",
      toString: function () {
        return this.url;
      }
    }